import React, { memo } from 'react';
import { Handle, Position } from '@xyflow/react';
import './ProcessNodes.css';

/**
 * HTTP Node -- canvas card for the `http` execution type.
 *
 * Reads `data.http_config` for the request method / URL preview so the
 * card surfaces enough information to identify the node at a glance
 * without opening the properties panel.
 */
function HttpNode({ data, selected }) {
  const inputCount = data.inputs?.length || 0;
  const outputCount = data.outputs?.length || 0;
  const cfg = data.http_config || {};
  const method = (cfg.method || 'GET').toUpperCase();
  const rawUrl = cfg.url || '';
  const urlPreview = rawUrl.length > 38 ? `${rawUrl.slice(0, 35)}…` : rawUrl;

  return (
    <div className={`process-node http-node ${selected ? 'selected' : ''}`}>
      <Handle type="target" position={Position.Left} className="node-handle input-handle" />

      <div className="node-header">
        <span className="node-icon">🌐</span>
        <span className="node-type-badge http">HTTP</span>
      </div>

      <div className="node-body">
        <div className="node-name">{data.name || 'HTTP Node'}</div>
        {data.description && (
          <div className="node-description">{data.description}</div>
        )}
        <div className="node-http-summary">
          <span className={`http-method http-method-${method.toLowerCase()}`}>{method}</span>
          <span className="http-url" title={rawUrl}>{urlPreview || '(no URL)'}</span>
        </div>
      </div>

      <div className="node-footer">
        <div className="node-meta">
          <span className="meta-item">
            <span className="meta-icon">↓</span>
            {inputCount} input{inputCount !== 1 ? 's' : ''}
          </span>
          <span className="meta-item">
            <span className="meta-icon">↑</span>
            {outputCount} output{outputCount !== 1 ? 's' : ''}
          </span>
        </div>
        <div className="node-model">
          {(cfg.auth_type && cfg.auth_type !== 'none') ? `auth: ${cfg.auth_type}` : 'no auth'}
        </div>
      </div>

      <Handle type="source" position={Position.Right} className="node-handle output-handle" />
    </div>
  );
}

export default memo(HttpNode);
